export const User = () => {
  return {
    user_id: '',
    nickname: '',
    username: '',
    email: '',
    avatar: '',
    end_date: '',
    vod_end_date: '',
    data: {
      express: {
        lastname: '',
        firstname: '',
        mobile_code: '',
        mobile: '',
        wechat: '',
        country: '',
        address: '',
        city: '',
        province: '',
        postal: ''
      }
    }
  }
}

export const Trade = () => {
  return {
    trade_id: '',
    trade_no: '',
    status: '',
    price: '',
    data: {
      device: {
        device_id: '',
        offset_time: '',
        end_time: '',
        time: ''
      }
    },
    product_data: [],
    payment_data: {},
    express_data: {
      lastname: '',
      firstname: '',
      mobile_code: '',
      mobile: '',
      wechat: '',
      country: '',
      address: '',
      city: '',
      province: '',
      postal: '',
      carrier: '',
      ship_no: ''
    },
    tracking: []
  }
}

export const Device = () => {
  return {
    device_id: '',
    mac: '',
    status: '',
    end_time: '',
    active_time: '',
    model: '',
    client: {
      ip: '-',
      is_connect: false,
      ipinfo: {
        as: '',
        country: '',
        city: '',
        org: ''
      }
    }
  }
}

export const MemberPlan = () => {
  return {
    plan_id: '',
    name: '',
    price: '',
    desp: '',
    sign: ''
  }
}

export const Vod = () => {
  return {
    vod_id: '',
    vod_pic: '',
    vod_area: '',
    vod_name: '',
    vod_year: '',
    type_name: '',
    vod_actor: '',
    vod_content: '',
    vod_remarks: '',
    vod_director: '',
    vod_play_urls: [],
    vod_series: []
  }
}



// WEBPACK FOOTER //
// ./src/api/model.js